import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Link } from 'react-router-dom';

export const StyledAppBar = styled(AppBar)(({ theme }) => {
  const bgColor = theme.wl?.header?.['background-color'];
  const contrastText = theme.wl?.header?.['contrast-text'];
  const backgroundColor = bgColor ? `#${bgColor}` : theme.palette.primary.main;
  const contrastTextColor = contrastText ? `#${contrastText}` : theme.palette.getContrastText(backgroundColor);

  return {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif;',
    fontSize: 14,
    color: `${contrastTextColor} !important`,
    backgroundColor: `${backgroundColor} !important`,
    zIndex: 1200
  };
});

export const StyledToolbar = styled(Toolbar)({
  paddingLeft: 4
});

export const Account = styled('div')({
  textAlign: 'right',
  paddingTop: 2
});

export const Timezone = styled('div')({
  fontSize: 'smaller',
  marginTop: 4
});

export const Logo = styled('span')({
  flexGrow: 1,
  marginLeft: 16,
  marginRight: 70,
  textAlign: 'right'
});

export const CompanyImgLogo = styled('img')({
  height: '56px',
  maxWidth: '137px',
  float: 'right'
});

export const AccountName = styled(Link)(({ theme }) => {
  const bgColor = theme.wl?.header?.['background-color'];
  const contrastText = theme.wl?.header?.['contrast-text'];
  const backgroundColor = bgColor ? `#${bgColor}` : theme.palette.primary.main;
  const contrastTextColor = contrastText ? `#${contrastText}` : theme.palette.getContrastText(backgroundColor);

  return {
    color: contrastTextColor,
    borderBottom: `1px ${contrastTextColor} solid`,
    paddingBottom: 1,
    textDecoration: 'none',
    '&:hover': {
      borderBottom: 0
    }
  };
});

export const UserNotificationsMob = styled('span')({
  position: 'absolute',
  right: 4
});
